import { useContext } from 'react';
import { StoryDetailContext, StoryDetailContextType } from '#advertStory/detail';

const useStoryDetailContext = () => useContext<StoryDetailContextType>(StoryDetailContext);

export { useStoryDetailContext };
